import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { CMS } from '../../utils/CMS';
import { Checkbox } from '../../components/Checkbox/Checkbox';
import { setSeparateStay } from '../../redux/currentSearch/actions';
import { getSeparateStay, shouldShowSeparateStay } from '../../redux/currentSearch/selectors';
import { withPageContext } from '../../utils/PageContext/PageContext';
import { SeparateStayCalendars } from './SeparateStayCalendars';
import { TrackingUtils } from '../../utils';

export class SeparateStay extends Component {
    onSeparateStayChange = () => {
        const { setSeparateStay, separateStay, trackEvent } = this.props;
        const enabled = !separateStay.enabled;
        const action = TrackingUtils.ACTION.DP;
        const label = TrackingUtils.LABEL.separateStay({ enabled });
        trackEvent({ action, label });
        setSeparateStay({
            ...separateStay,
            enabled,
        });
    };

    render() {
        const { separateStay, shouldShowSeparateStay } = this.props;
        const checkboxProps = {
            id: 'separate-stay-switcher',
            checked: separateStay.enabled,
            onChange: this.onSeparateStayChange,
            disabled: !shouldShowSeparateStay,
        };
        return (
            <React.Fragment>
                { shouldShowSeparateStay && (
                    <div className="odf-row odf-row-top odf-row-nogutter odf-space-outer-top-s">
                        <div className="odf-col odf-col-span6">
                            <div className="odf-space-outer-top-s">
                                <Checkbox {...checkboxProps}>
                                    <CMS id='flightsManager.accommodation.checkInDates' />
                                </Checkbox>
                            </div>
                        </div>
                        {separateStay.enabled && (
                            <SeparateStayCalendars show />
                        )}
                    </div>
                )}
            </React.Fragment>
        );
    }
}

SeparateStay.propTypes = {
    setSeparateStay: PropTypes.func.isRequired,
    separateStay: PropTypes.shape({
        enabled: PropTypes.bool,
        checkInDate: PropTypes.instanceOf(Date),
        checkOutDate: PropTypes.instanceOf(Date),
    }),
    shouldShowSeparateStay: PropTypes.bool.isRequired,
    trackEvent: PropTypes.func.isRequired,
};

SeparateStay.defaultProps = {
    separateStay: {
        enabled: false,
    },
};

const mapStateToPropsSelector = createStructuredSelector({
    separateStay: getSeparateStay,
    shouldShowSeparateStay: shouldShowSeparateStay,
});

const ConnectedSeparateStay = connect(mapStateToPropsSelector, {
    setSeparateStay,
})(withPageContext(SeparateStay));

export { ConnectedSeparateStay };
